import { render, staticRenderFns } from "./ProblemArea.vue?vue&type=template&id=32656110&scoped=true&"
import script from "./ProblemArea.vue?vue&type=script&lang=js&"
export * from "./ProblemArea.vue?vue&type=script&lang=js&"
import style0 from "./ProblemArea.vue?vue&type=style&index=0&id=32656110&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32656110",
  null
  
)

export default component.exports